import {IDestroy} from "./GameObject";
import {GameJuggler, GameTween, IAnimatable} from "./GameJuggler";
import * as PIXI from 'pixi.js';
import {AbstractPixiRoot} from "../AbstractPixiRoot";
import {Easing} from "@tweenjs/tween.js";

export class GameView extends PIXI.Container implements IDestroy, IAnimatable {

  public root!:AbstractPixiRoot;

  constructor(...args: any[]) {
    super();
    // this.interactive = false;
  }

  public onResize(): void {
  }

  override set interactive(value: boolean) {
    super.interactive = value;
    this.interactiveChildren = value;
  }

  protected get pulsatingDisplayObject(): GameView {
    return this;
  }

  protected _pulsateTween?: GameTween;

  public startPulsating(scaleDiff: number = 0.03, time: number = 0.6) {
    this._pulsateTween?.destroy();
    // console.log(this.pulsatingDisplayObject.scale.x, this.pulsatingDisplayObject.scale.y);

    this._pulsateTween = this.juggler.tween(this.pulsatingDisplayObject, 2, {
      scale: {
        y: this.pulsatingDisplayObject.scale.y - scaleDiff,
        x: this.pulsatingDisplayObject.scale.x - scaleDiff * 3,
      }
    })
      .repeat(Infinity)
      .yoyoFix((t: any) => Easing.Linear.InOut(t)).start();
  }

  public continuePulsating(): void {
    // Main.log('continuePulsating')
    if (this._pulsateTween) {
      this.juggler.addAnimatable(this._pulsateTween);
    }
  }

  public stopPulsating(): void {
    if (this._pulsateTween) {
      this.juggler.removeAnimatable(this._pulsateTween);
    }
  }

  protected _juggler?: GameJuggler;

  public advanceTime(delta: number) {
  }

  addToJuggler(): void {
    this.juggler?.addAnimatable(this);
  }

  removeFromJuggler() {
    this.juggler?.removeAnimatable(this);
  }

  onRemovedFromJuggler() {

  }

  public get juggler() {
    return this._juggler || this.root?.juggler;
  }

  public set juggler(value: GameJuggler) {
    this._juggler = value;
  }


  destroyChildren() {
    while (this.children.length > 0) {
      const child = this.removeChildAt(0);
      if ('destroy' in child && typeof child.destroy === 'function') {
        child.destroy({ children: true });
      }
    }
  }

  override destroy() {
    if (this.destroyed) {
      return;
    }
    this._pulsateTween?.destroy();
    this.removeFromJuggler();
    this.removeFromParent();
    this.destroyChildren();
    super.destroy({
      children: true
    });
  }

}
